import React, { useEffect, useState, useContext } from 'react'
import classNames from 'classnames'
import { RadioInputProps } from './RadioInput.d'
import {
  FormikContext,
  FormikContextProps
} from '@toasttab/shared/src/hooks/useFormikContext'
import { generateUUID } from '@toasttab/shared/src/utils/siteUtils'
import {
  wrapperClassNames,
  labelClassNames,
  inputClassNames,
  optionLabelClassNames,
  inputLabelClassNames
} from './RadioInputClassnames'

const RadioInput = ({
  label,
  name,
  onChange,
  options,
  value
}: RadioInputProps) => {
  const [inputValue, setInputValue] = useState<string>(value as string)
  const formik: FormikContextProps = useContext(FormikContext) || null
  const id = generateUUID()

  useEffect(() => {
    if (value === '' && options?.length > 0) {
      formik?.formik?.setFieldValue(name, options[0].value)
      setInputValue(options[0].value)
    }
  }, [formik])

  const handleInputChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(ev.target.value)
    if (typeof onChange === 'function') {
      onChange(ev)
    }
  }

  // const wrapperClassNames = classNames({
  //   'mr-3 min-w-[300px] flex-1 basis-3/4 w-auto brand2': true
  // })

  // const labelClassNames = classNames({
  //   'text-[14px] font-semibold text-default mb-1 flex items-center font-effra mb-4':
  //     true
  // })

  // const inputClassNames = classNames({
  //   'relative mr-2 w-5 h-5': true,
  //   'appearance-none rounded-full border-2 border-solid border-gray-100 after:block after:absolute after:top-0 after:bottom-0 after:left-0 after:right-0 after:w-full after:content-[""] after:border-2 after:border-solid after:border-transparent after:rounded-full':
  //     true,
  //   'hover:after:bg-gray-100 hover:after:border-white hover:checked:after:bg-blue-75 checked:border-blue-75 checked:after:bg-blue-75 checked:after:border-white':
  //     true
  // })

  // const optionLabelClassNames = classNames({
  //   'text-[14px] font-normal font-effra text-secondary tracking-[0.2px]': true
  // })

  return (
    <div className={wrapperClassNames} data-testid='RadioInput'>
      <fieldset id={name}>
        {label ? <legend className={labelClassNames}>{label}</legend> : null}
        {options
          ? options.map(
              ({ value: optionValue, label: optionLabel }, i: number) => {
                return (
                  <label
                    className={inputLabelClassNames}
                    htmlFor={`${name}-${i}-${id}`}
                    key={`${name}-${i}-${id}`}
                  >
                    <input
                      checked={inputValue === optionValue}
                      className={inputClassNames}
                      id={`${name}-${i}-${id}`}
                      name={name}
                      onChange={(ev) => handleInputChange(ev)}
                      type='radio'
                      value={optionValue}
                    />
                    <span className={optionLabelClassNames}>{optionLabel}</span>
                  </label>
                )
              }
            )
          : null}
      </fieldset>
    </div>
  )
}

export default RadioInput
